<script>
export const pageName = 'tools-rsos-list';
export const pageRoute = '/tools/rsos';
export const title = 'RSOs'

import { certLevelToLevel, insuranceStatus, rsoLevelToLevel } from '../../../functions/domain/certification-utils.js';
import { queries } from '../../js/lib/functions.js';
import ukraLogo from '../../img/ukra-logo.png'
import { getCurrentUserId } from '../../js/auth.js';
import { listenToProjection } from '@trullock/firebase-client';
import UserView from '../../../functions/domain/users/userView.js';

export default {
	data() {
		return {
			rsos: [],
			rsoLevelToLevel,
			certLevelToLevel,
			insuranceStatus,
			ukraLogo,
			showViewMember: false,
			ready: false
		}
	},

	methods: {
		async boot(opts) {
			await listenToProjection([UserView, getCurrentUserId()], async user => {
				this.showViewMember = user.isAdmin;
			});
		},
		async show() {
			let rsos = await queries.rso.listRSOs();
			this.rsos = rsos;
			this.ready = true;
		}
	}
}

</script>
<template>
	<div v-if="ready" class="container py-5">
		<h1 class="display-4 text-center mb-3">RSOs</h1>
		<p class="text-muted text-center">These are all UKRA RSOs.</p>
			
		
		<div class="row justify-content-center">
			<div class="col col-12 col-lg-8 ">
				<div class="card">
					<div class="card-body">
						<div class="list-group list-group-flush my-n3">
							<div v-for="rso in rsos" class="list-group-item">
								<div class="row align-items-center">
									<div class="col-auto">
										<div class="avatar avatar-xl">
											<img class="avatar-img rounded-circle" :src="rso.avatar">
										</div>
									</div>
									<div class="col">
										<h2 class="mb-1">{{ rso.name }}</h2>
										<span v-if="rso.membership.status == 'active'" class="badge badge-success badge-lg m-2"> <span class="fe fe-check-circle"></span> Active Member</span>
										<span v-if="rso.membership.status == 'expired'" class="badge badge-danger badge-lg m-2"><span class="fe fe-x-circle"></span> Expired Member</span>
										<span v-if="rso.membership.status == 'non-member'" class="badge badge-danger badge-lg m-2"><span class="fe fe-x-circle"></span> Non-Member</span>
										
										<span v-if="rso.insurance.status == 'active'" class="badge badge-success badge-lg m-2"><span class="fe fe-check-circle"></span> Insurance Valid</span>
										<span v-else-if="rso.insurance.status == 'expired'" class="badge badge-danger badge-lg m-2"><span class="fe fe-x-circle"></span> Insurance Expired</span>
										<span v-else class="badge badge-warning badge-lg m-2"><span class="fe fe-x-circle"></span> Insurance Not Validated</span>
										
										<span v-if="rso.ukra.role" class="badge badge-lg m-2 badge-ds mb-3"><img :src="ukraLogo" alt="UKRA Logo" /> UKRA {{ rso.ukra.role }}</span>

										<br />

										<span class="badge badge-ds badge-lg m-2"><span class="fe fe-award"></span> HPR {{ certLevelToLevel(rso.certification.level) }}</span>
									
										<span v-if="rso.rso.level" class="badge badge-ds badge-lg m-2"><span class="fe fe-shield"></span> {{ rsoLevelToLevel(rso.rso.level) }} RSO</span>
									
										<span class="badge badge-ds badge-lg m-2"><span class="fe fe-check-square"></span> MAP Assessor</span>
										
									</div>
									<div v-if="showViewMember" class="col-auto">
										<a :href="`/admin/user/${rso.id}`" class="btn btn-sm btn-outline-primary">View member</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>
